import type { CreateQualificationFields, Specialty } from '@quromedical/models';
import { CrudForm } from 'components/form';
import type { Field, SelectOption } from 'components/types';
import type { FormikErrors } from 'formik';
import { specialtyFetcher } from 'integration';
import type React from 'react';
import { useCallback } from 'react';
import { strings } from 'strings';

interface PractitionerQualificationFormProps {
  onValidChange: (data?: CreateQualificationFields) => void;
  showErrors: boolean;
}

export const createQualificationFields = (
  initialQualification?: SelectOption<Specialty>,
): Field<CreateQualificationFields>[] => {
  const initialSelection = initialQualification && [initialQualification];

  return [
    {
      subfields: [
        {
          type: 'combobox-single',
          searchable: true,
          label: strings.Specialty,
          key: 'qualificationCode',
          initialSelection,
          fetcher: specialtyFetcher,
        },
        {
          key: 'registrationNumber',
          label: strings.RegistrationNumber,
          type: 'text-box',
        },
      ],
    },
  ];
};

export const PractitionerQualificationForm: React.FC<
  PractitionerQualificationFormProps
> = ({ onValidChange, showErrors }) => {
  const fields = createQualificationFields();

  const onChange = useCallback(
    (
      data: Partial<CreateQualificationFields>,
      _: FormikErrors<CreateQualificationFields>,
      hasErrors: boolean,
    ) => {
      if (hasErrors) {
        onValidChange(undefined);
      } else {
        // casting since data is validated
        const result = data as CreateQualificationFields;

        onValidChange(result);
      }
    },
    [onValidChange],
  );

  return (
    <CrudForm
      title={strings.FormLabelPractitionerQualificationDetails}
      fields={fields}
      initialValues={{}}
      onChange={onChange}
      showErrors={showErrors}
      validateOnMount
      showSubmitButton={false}
      hasCard={false}
    />
  );
};
